<div class="splash-card-header w-100 text-center">
    <img
        class="splash-card-header-logo"
        src="/assets/icons/logo_header_dark.png"
    />
    <div class="splash-card-header-title">Authenticating...</div>
</div>
<q-auth-frame></q-auth-frame>
